import { Button, Container, Navbar } from 'react-bootstrap'
import classNames from 'classnames'
import styles from '../assets/scss/MaNavBar.module.scss'
import { t } from 'i18next'
import { type ReactElement } from 'react'

interface NavBarProps {
  readonly onSubmit?: React.MouseEventHandler<HTMLButtonElement> | undefined
  readonly formDirty: boolean
}

export default function MaNavBar ({
  onSubmit,
  formDirty
}: NavBarProps): ReactElement {
  return (
    <Navbar
      as="header"
      sticky="top"
      expand="md"
      className={classNames(
        styles['disabled-panel'],
        'disabled-panel border-0 shadow-none m-1'
      )}
    >
      <Container fluid className="p-0 justify-content-end">
        <Button
          className={classNames(styles.button, 'rounded-2')}
          onClick={onSubmit}
          disabled={!formDirty}
        >
          {t('common.button.labels.saveChanges')}
        </Button>
      </Container>
    </Navbar>
  )
}
